export enum EditableItem {
	Text = 'data-uprez-text',
	Image = 'data-uprez-image',
	Video = 'data-uprez-video',
}

export const editableId = 'data-uprez-id';
export const editorStylesId = 'editor-styles';
export const editorFontsId = 'editor-fonts';
export const editorGoogleFontsId = 'editor-google-fonts';
export const editedMediaScriptAttribute = 'data-uprez-media-script';

export enum SupportedParagraphStyle {
	LineHeight = 'lineHeight',
	TextAlign = 'textAlign',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/htmlEditor/constants.ts